"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var Node_1 = __importDefault(require("./Node"));

var Expression_1 = __importDefault(require("./Expression"));

var ColourChisel_1 = __importDefault(require("../../ColourChisel"));

var Path =
/** @class */
function (_super) {
  __extends(Path, _super);

  function Path() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.expressions = [];
    return _this;
  }

  Path.prototype.parse = function () {
    this.tokenizer.checkNextAndPop("[");
    var first = true;
    var next = this.tokenizer.getNext();

    while (next === "," || first === true) {
      var expression = new Expression_1["default"](this.tokenizer);
      expression.parse();
      this.expressions.push(expression);
      next = this.tokenizer.getNextAndPop();
      first = false;
    }

    if (next !== "]") {
      throw new Error("Invalid closing of path.");
    }
  };

  Path.prototype.typeCheck = function () {
    this.expressions.forEach(function (e) {
      return e.typeCheck();
    });
  };

  Path.prototype.evaluate = function () {
    return new ColourChisel_1["default"](this.expressions.map(function (e) {
      return e.evaluate();
    }));
  };

  return Path;
}(Node_1["default"]);

exports["default"] = Path;